export default __webpack_public_path__ + "static/hero-daeyeon-1dc01894cd2aed40a0c7c4e905b65562.png";